import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";

import "./styles.scss";

import DefaultSlider from "../DefaultSlider";

import NextArrow from "../../assets/img/arrows/nextArrow.png";
import PreviousArrow from "../../assets/img/arrows/previousArrow.png";

import { useMainContext } from "../../store/Context";

import Preset from "./presets.json";

import { PRESETS } from "../DefaultSlider";

const Sugestions = ({ onSelectPreset }) => {
  const [
    unavailable,
    // setUnavailable // disabled by ticket request LOEWEDICE-27
  ] = useState([]);
  const [stockList, setStockList] = useState({});

  const {
    getProductDicesNumbner,
    // setSuggestion, // disabled by ticket request LOEWEDICE-27
    isMobile,
    dices: dicesList,
    straps
  } = useMainContext();
  const diceNumber = isMobile ? 0 : getProductDicesNumbner();

  useEffect(() => {
    if (!dicesList) {
      return;
    }

    const stockList = {};
    for (let i = 0; i < dicesList.length; i++){
      dicesList[i].dices.forEach((dice) => {
        stockList[String(dice.id)] = dice.stock
      });
    }

    for (let i = 0; i < straps.length; i++) {
      stockList[String(straps[i].id)] = straps[i].stock
    }

    setStockList(stockList);
  }, [dicesList]);

  useEffect(() => {
    if (Object.keys(stockList).length) {
      const unavailableList = [];
      Object.keys(Preset).forEach((key, index) => {
        const { dices, strap } = Preset[key];
        if (!stockList[strap]) {
          unavailableList.push(index);
          return;
        }
        
        let available = true;
        for (let i = 1; i < dices.length; i++) {
          if (!stockList[dices[i].id]) {
            available = false;
            break;
          }
        }

        if (!available) {
          unavailableList.push(index);
        }
      });
      // setUnavailable(unavailableList) // disabled by ticket request LOEWEDICE-27
    }
  }, [stockList])

  // const onSelectSuggestion = (index) => {
  //   if (unavailable.includes(index)) {
  //     return;
  //   }
  //
  //   const { dices, strap } = Preset[index];
  //   setSuggestion(dices, strap);
  //   onSelectPreset();
  // }; // disabled by ticket request LOEWEDICE-27

  const commonProps = {
    arrows: true,
    nextArrow: <img src={NextArrow} alt="next-arrow" />,
    prevArrow: <img src={PreviousArrow} alt="next-arrow" />,
  };
  const extraProps = {
    slidesToShow: 5,
    slidesToScroll: 5,
    ...commonProps,
  };

  const extraPropsMobile = {
    slidesToShow: 1,
    slidesToScroll: 1,
    ...commonProps,
  };

  return (
    <div className="Suggestion">
      <div className="Suggestion__heading Suggestion__heading-suggestion">
        <div style={{ height: diceNumber * 20 }} />
        <div className="Suggestion__title">
          <FormattedMessage id="App.suggestion" />
        </div>
        {/* disabled by ticket request LOEWEDICE-27 */}
        {/*
          <div className="Suggestion__description">
           <FormattedMessage id="App.suggestionText" />
          </div>
        */}
      </div>
      <div className="Suggestion__slider">
        <DefaultSlider
          extraProps={isMobile ? extraPropsMobile : extraProps}
          itemClassName={"Suggestion__slide"}
          containerClassName={"Suggestion__container-slider"}
          // onSelectSuggestion={onSelectSuggestion} // disabled by ticket request LOEWEDICE-27
          type={PRESETS}
          unavailable={unavailable}
        />
      </div>
    </div>
  );
};

export default Sugestions;
